import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';
 
@Component({
  selector: 'app-payment-success',
  templateUrl: './payment-success.component.html',
  styleUrls: ['./payment-success.component.scss']
})
export class PaymentSuccessComponent implements OnInit {
  orderId: string | null = null;
  status: string | null = null;
 
  constructor(private route: ActivatedRoute) { }
 
  ngOnInit(): void {
    this.extractParams();
  }
 
  extractParams(): void {
    
    // Try route query params first
    this.route.queryParams.subscribe(params => {
      this.orderId = params['order_id'] || params['orderId'] || null;
      this.status = params['status'] || null;
    });
 
    // Fallback to URL query string
    if (!this.orderId && !this.status) {
      const url = window.location.href;
      if (url.includes('?')) {
        const httpParams = new HttpParams({ fromString: url.split('?')[1] });
        this.orderId = httpParams.get('order_id');
        this.status = httpParams.get('status');
      }
    }
  }
 
  printReceipt(): void {
    const printCard = document.getElementById('printable-card');
    if (!printCard) {
      console.error('Print card not found');
      return;
    }
 
    // Clone the card element to get all rendered content
    const cardClone = printCard.cloneNode(true) as HTMLElement;
    
    // Remove the print button from the clone
    const printButtonContainer = cardClone.querySelector('.print-button-container');
    if (printButtonContainer) {
      printButtonContainer.remove();
    }
 
    // Get computed styles for the card
    const computedStyles = window.getComputedStyle(printCard);
    
    // Get all stylesheets
    let allStyles = '';
    for (let i = 0; i < document.styleSheets.length; i++) {
      try {
        const sheet = document.styleSheets[i];
        if (sheet.href) {
          allStyles += `<link rel="stylesheet" href="${sheet.href}">`;
        } else if (sheet.cssRules) {
          for (let j = 0; j < sheet.cssRules.length; j++) {
            allStyles += `<style>${sheet.cssRules[j].cssText}</style>`;
          }
        }
      } catch (e) {
        // Cross-origin stylesheets will throw an error, skip them
      }
    }
 
    // Create a new window for printing
    const printWindow = window.open('', '_blank', 'width=800,height=600');
    if (!printWindow) {
      alert('Please allow popups to print the receipt');
      return;
    }
 
    // Write the content to the print window
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Payment Receipt</title>
          <meta charset="utf-8">
          ${allStyles}
          <style>
            * {
              margin: 0;
              padding: 0;
              box-sizing: border-box;
            }
            body {
              margin: 0;
              padding: 20px;
              display: flex;
              justify-content: center;
              align-items: center;
              min-height: 100vh;
              background: #f5f5f5;
              font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
            }
            .thank-you-card {
              background: #ffffff !important;
              border-radius: 8px !important;
              padding: 40px !important;
              max-width: 500px !important;
              width: 100% !important;
              box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
              text-align: center !important;
            }
            .thank-you-title {
              font-size: 28px !important;
              font-weight: 600 !important;
              color: #333 !important;
              margin: 0 0 16px 0 !important;
            }
            .thank-you-message {
              font-size: 16px !important;
              color: #666 !important;
              margin: 0 0 32px 0 !important;
            }
            .order-info {
              background: #f8f9fa !important;
              border-radius: 6px !important;
              padding: 20px !important;
              text-align: left !important;
            }
            .info-row {
              display: flex !important;
              justify-content: space-between !important;
              padding: 12px 0 !important;
              border-bottom: 1px solid #e0e0e0 !important;
            }
            .info-row:last-child {
              border-bottom: none !important;
            }
            .info-label {
              font-size: 14px !important;
              font-weight: 600 !important;
              color: #666 !important;
            }
            .info-value {
              font-size: 14px !important;
              font-weight: 600 !important;
              color: #333 !important;
              word-break: break-all !important;
            }
            .print-button-container {
              display: none !important;
            }
            @media print {
              body {
                background: #ffffff !important;
                padding: 0 !important;
              }
            }
          </style>
        </head>
        <body>
          ${cardClone.outerHTML}
        </body>
      </html>
    `);
 
    printWindow.document.close();
 
    // Wait for content to load, then print
    setTimeout(() => {
      printWindow.focus();
      printWindow.print();
      // Close window after printing (user can cancel if needed)
      setTimeout(() => {
        printWindow.close();
      }, 100);
    }, 500);
  }
}